import { RDNaturalDisturbanceEvent } from '@cibo/core'
import { Stack, Tooltip, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface NaturalDisturbanceCellDisplayProps {
  value: any
}

export const NaturalDisturbanceCellDisplay = ({ value }: NaturalDisturbanceCellDisplayProps) => {
  const { t } = useTranslation('@cibo/landmanager/NaturalDisturbance')

  if (value?.input?.events?.length) {
    return (
      <Tooltip
        title={
          <Stack spacing={1} padding={1}>
            {value.input?.events.map(
              ({ month, disturbance, lossPer }: RDNaturalDisturbanceEvent, index: number) => (
                <Stack key={index}>
                  <Typography variant="body1" fontWeight="bold">
                    {t(`month_${month}`)}
                  </Typography>
                  <Typography variant="body2">
                    {t(`disturbance_${disturbance}`)} - {t(`percent`, { number: lossPer })}
                  </Typography>
                </Stack>
              )
            )}
          </Stack>
        }
      >
        <Typography variant="body1">
          {t('events', { count: value.input?.events?.length })}
        </Typography>
      </Tooltip>
    )
  }

  return <Typography>{t('none')}</Typography>
}
